module.exports = __webpack_public_path__ + "media/day/374-aec69ca2.svg";